module.exports = __webpack_public_path__ + "assets/b95.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b95.png
// module id = 688
// module chunks = 0